export const deviceUtils = {
	isMobile() {
		return window.innerWidth < 480;
	},

	isTablet() {
		return window.innerWidth < 768;
	},

	isLaptop() {
		return window.innerWidth < 1024;
	},

	// Same breakpoint as the legacy windowHelper.isMobile() (m.eagle/js/Main.js) — for a Vue screen opened from a
	// legacy view that switches its own layout on it, so both sides agree on which device they are on.
	isLegacyMobile() {
		return window.innerWidth <= 885;
	},

	isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	},

	isIOS() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
	},

	isTouchMode() {
		return window.innerWidth <= 1024;
	},

	isLandscape() {
		return window.innerWidth > window.innerHeight;
	},

	isIpadLandscape() {
		return this.isIOS() && this.isLandscape();
	},

	isIpadPortrait() {
		return this.isIOS() && !this.isLandscape();
	},
};
